import { TAdPlacement } from '@x/common/ads/ad.config';
import { DeviceSizeMediaQueries, DeviceSizes } from '@x/common/responsive';
import { TShopAdMedia } from '@x/ecommerce/shop-client';

export interface IAdMediaDimensions {
  width: number;
  height?: number;
}
type TAdMediaConfig = Record<TAdPlacement, IAdMediaDimensions> & {
  breakpoints?: Partial<Record<DeviceSizes, Omit<TAdMediaConfig, 'breakpoints'>>>;
};

const DEFAULT_MEDIA_CONFIG: TAdMediaConfig = {
  V_BANNER: { width: 330 },
  H_BANNER: { width: 1050 },
  CARD: { width: 320, height: 430 },
};

export const AD_MEDIA_CONFIG: TAdMediaConfig = {
  ...DEFAULT_MEDIA_CONFIG,
  breakpoints: {
    XS: {
      V_BANNER: { width: 300 },
      H_BANNER: { width: 600 },
      CARD: { width: 250, height: 400 },
    },
    SM: {
      V_BANNER: { width: 300 },
      H_BANNER: { width: 730 },
      CARD: { width: 340, height: 490 },
    },
    MD: {
      V_BANNER: { width: 300 },
      H_BANNER: { width: 1000 },
      CARD: { width: 300, height: 450 },
    },
    LG: {
      ...DEFAULT_MEDIA_CONFIG,
    },
  },
};

export function adMediaDimensions(
  breakpoint: DeviceSizes,
  placement: TAdPlacement,
): IAdMediaDimensions {
  // Get the default media configuration
  const defaultConfig = DEFAULT_MEDIA_CONFIG[placement];

  // Get the configuration for the specified breakpoint
  const breakpointConfig = AD_MEDIA_CONFIG.breakpoints?.[breakpoint]?.[placement];

  // Return the breakpoint specific configuration if it exists, otherwise the default
  return breakpointConfig || defaultConfig;
}

export function findLargestBreakpointMedia(
  images: TShopAdMedia[],
): TShopAdMedia | null | undefined {
  if (images.length === 0) return null;

  const reversedBreakpoints = [...Object.keys(DeviceSizeMediaQueries)].reverse();
  let largestImage = null;

  for (const breakpoint of reversedBreakpoints) {
    largestImage = images.find((img) => img.mediaQuery.toUpperCase() === breakpoint);
    if (largestImage) break;
  }

  return largestImage;
}

export function getUniqueMedia(media: TShopAdMedia[], placement: TAdPlacement): TShopAdMedia[] {
  let mediaByPlacement = media.filter((m) => m.placement === placement);
  return Array.from(new Set(mediaByPlacement.map((item) => item.mediaQuery))).map(
    (mediaQuery) => mediaByPlacement.find((item) => item.mediaQuery === mediaQuery)!,
  );
}
